import React, {InputHTMLAttributes, useRef} from 'react';
import {FormGroup, InputGroup, InputGroupAddon, InputGroupText, Label} from "reactstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {IconProp} from "@fortawesome/fontawesome-svg-core";
import {Controller, useFormContext} from "react-hook-form";
import {Validate, ValidationRule, ValidationRules} from "react-hook-form";
import InputErrorsComponent from "./InputErrorsComponent";
import Action from '../../../Models/Action';
import ButtonAction from "../ButtonAction";

interface Props extends Omit<Omit<Omit<InputHTMLAttributes<any>, 'pattern'>, 'name'>, 'size'> {
  name: string,
  label?: string,
  icon?: IconProp,
  validate?: Validate | Record<string, Validate>,
  pattern?: ValidationRule<RegExp>,
  render?: ((data: {
    onChange: (...event: any[]) => void;
    onBlur: () => void;
    value: any;
  }) => React.ReactElement<any, string | ((props: any) => React.ReactElement<any, string | any | (new (props: any) => React.Component<any, any, any>)> | null) | (new (props: any) => React.Component<any, any, any>)>) | undefined,
  actions?: Action[],
  defaultValue?:any,
  min?:any,
  size?: string,
  type?:string
}

const InputComponent: React.FC<Props> = ({
                                           render, icon, label, validate, required, pattern,
                                           className = "form-control", actions,
                                           size = "md",
                                           ...props
                                         }) => {

  const {register, errors, control} = useFormContext();
  const inputRef = useRef<HTMLInputElement | null>(null);

  const rules: ValidationRules = {
    required,
    validate,
    pattern,
    min: props.min,
    max: props.max,
    maxLength: props.maxLength,
    minLength: props.minLength,
  };

  const handleIconClick = () => inputRef.current && inputRef.current.focus();

  const controllerProps: any = {};
  if (props.defaultValue) {
    controllerProps.defaultValue = props.defaultValue;
  }

  return (
    <FormGroup>
      {
        label &&
        <Label>
          {label}
          {
            !props.readOnly && required && <sup>*</sup>
          }
        </Label>
      }

      {
        render ?
          <Controller
            {...controllerProps}
            control={control}
            rules={rules}
            min={props.min}
            name={props.name}
            render={render}
          /> :
          <InputGroup>
            {
              icon &&
              <InputGroupAddon addonType="prepend" onClick={handleIconClick}>
                <InputGroupText>
                  <FontAwesomeIcon icon={icon}/>
                </InputGroupText>
              </InputGroupAddon>
            }

            <input {...props} className={className} ref={(e) => {
              inputRef.current = e;
              register(e, rules);
            }} />

            {
              actions?.map((action: Action, index: number) => (
                <InputGroupAddon key={`action_${index}`} addonType="append">
                  {
                    action.element
                      ? action.element
                      : <ButtonAction action={action} size={size} />
                  }
                </InputGroupAddon>
              ))
            }

          </InputGroup>
      }

      <InputErrorsComponent name={props.name} errors={errors} rules={rules} />

    </FormGroup>
  );
};

export default InputComponent;
